<div class="register-number-outer-container">
  <div class="device-caption" *ngIf="!isOnboardingFlow">
    <adp-label [context]="preHeaderTextContext" labelKey="RegisterCellularDevice_PreSelectedDevice_DisplayName_Text"></adp-label>
  </div>
  <div class="info-container">
    <div class="headings-container" style="padding:0px !important;">
      <div class="heading">
        {{title}}
      </div>
      <div style="text-align: left;margin-bottom:25px;">
        <mat-icon style="color:#0070b9 !important;height:26px;width:26px;overflow:visible !important;"><ng-container *ngTemplateOutlet="infoIcon"></ng-container></mat-icon>
        <button class="link" (click)="handleViewIMEIInfo();"><adp-label labelKey="Onboarding_Diagnostic_ExtraInfo_IMEIInfo_Label"></adp-label></button>
      </div>
    </div>
    <div modal-body class="input-container">
      <form [formGroup]="imeiQuestionnaireForm" name="imeiQuestionnaireFormGroup" class="enter-phonenumber-form">
        <div class="row">
          <div>
            <mat-radio-group class="radio-group radio-group-container" sf-aria-label="Global_SelectOption_Aria_Label" formControlName="selectedConfirmation">
              <mat-radio-button style="text-align:left;" class="radio-field radio-button-container" value="YES"><adp-label labelKey="RegisterDiagnosticDevice_Imei_Questionnaire_Answer_Yes"></adp-label></mat-radio-button>
              <mat-radio-button style="text-align:left;" class="radio-field radio-button-container" value="NO"><adp-label labelKey="RegisterDiagnosticDevice_Imei_Questionnaire_Answer_No"></adp-label></mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div class="row" style="margin-top:40px;">
          <div><button class="register-phone-button" mat-flat-button color="accent"
              (click)="handleNextEvent()" [disabled]="!imeiQuestionnaireForm.valid"><adp-label
                labelKey="Global_Button_Next"></adp-label></button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<ng-template #redAlertIcon>

<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="64" height="64" rx="32" fill="#E16D01" fill-opacity="0.05"/>
  <path d="M32.0009 43.75C30.9676 43.75 30.126 42.9083 30.126 41.875C30.126 40.8417 30.9676 40 32.0009 40C33.0342 40 33.8758 40.8417 33.8758 41.875C33.8758 42.9083 33.0342 43.75 32.0009 43.75Z" fill="#E16D01"/>
  <path d="M32.0009 37.5C31.311 37.5 30.751 36.94 30.751 36.25V23.75C30.751 23.06 31.311 22.5 32.0009 22.5C32.6892 22.5 33.2509 23.06 33.2509 23.75V36.25C33.2509 36.9383 32.6892 37.5 32.0009 37.5Z" fill="#E16D01"/>
  <path d="M15.7882 50C15.2099 50 14.6333 49.865 14.1166 49.6117C13.2117 49.1667 12.5317 48.3933 12.2051 47.4367C11.8784 46.48 11.9434 45.4517 12.3901 44.5467L28.176 12.3817C28.5893 11.54 29.281 10.85 30.1209 10.4367C30.7109 10.1467 31.3409 10 31.9942 10C33.6341 10 35.1024 10.9117 35.824 12.3817L51.6117 44.545C51.865 45.0617 52 45.6383 52 46.2167C52 47.2283 51.605 48.18 50.8884 48.8933C50.1751 49.6067 49.2251 50 48.2152 50H15.7882ZM31.9959 12.5C31.7275 12.5 31.4659 12.56 31.2242 12.68C30.8776 12.85 30.5909 13.1367 30.4209 13.4833L14.6333 45.6483C14.32 46.285 14.5833 47.0567 15.2199 47.3683C15.3949 47.455 15.5899 47.5 15.7849 47.5H48.2135C48.5585 47.5 48.8801 47.3667 49.1235 47.125C49.3668 46.8817 49.5001 46.56 49.5018 46.2167C49.5018 46.02 49.4568 45.825 49.3701 45.65L33.5791 13.4833C33.2858 12.8867 32.6658 12.5 31.9959 12.5Z" fill="#E16D01"/>
  </svg>

</ng-template>

<ng-template #infoIcon>

  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2585_54571)">
    <path d="M13 15.5C12.1727 15.5 11.5 14.8273 11.5 14V11.5H11C10.724 11.5 10.5 11.276 10.5 11C10.5 10.724 10.724 10.5 11 10.5H11.5C12.0513 10.5 12.5 10.9487 12.5 11.5V14C12.5 14.276 12.724 14.5 13 14.5H13.5C13.776 14.5 14 14.724 14 15C14 15.276 13.776 15.5 13.5 15.5H13Z" fill="currentColor"/>
    <path d="M11.75 9.5C12.1642 9.5 12.5 9.16421 12.5 8.75C12.5 8.33579 12.1642 8 11.75 8C11.3358 8 11 8.33579 11 8.75C11 9.16421 11.3358 9.5 11.75 9.5Z" fill="currentColor"/>
    <path d="M12 20C7.58867 20 4 16.4113 4 12C4 7.58867 7.58867 4 12 4C16.4113 4 20 7.58867 20 12C20 16.4113 16.4113 20 12 20ZM12 5C8.14 5 5 8.14 5 12C5 15.86 8.14 19 12 19C15.86 19 19 15.86 19 12C19 8.14 15.86 5 12 5Z" fill="currentColor"/>
    </g>
    <defs>
    <clipPath id="clip0_2585_54571">
    <rect width="16" height="16" fill="white" transform="translate(4 4)"/>
    </clipPath>
    </defs>
    </svg>

    </ng-template>
